export default "__VITE_ASSET__19a631d0__"